<template>
  <div class="minidiv pt-3 mb-3 pb-3">
    <div class="p-1">
      <div class="p-1">
        <div class="flex-parent">
          <p class="test-title">{{ orgtestspace.test_title }}</p>
          <p v-if="orgtestspace.test_module == 'Competition'">
            <b-icon-trophy-fill color="gold"></b-icon-trophy-fill>
          </p>
          <p class="written-class">
            <span style="font-style: italic; font-size: 14px"
              >Taken by: {{ formatNumberK(orgtestspace.takers_taken) }}
            </span>
            <b-icon-person />
          </p>
        </div>

        <div class="flex-parent2 mb-3">
          <b-badge
            v-for="subject in orgtestspace.test_subjects"
            variant="success"
            size="lg"
            :key="subject"
            >{{ subject }}</b-badge
          >
        </div>
        <div class="flex-parent2">
          <p>
            <b-badge
              :disabled="true"
              :variant="orgtestspace.test_status == 'Closed' ? 'danger' : 'info'"
              >{{ orgtestspace.test_status }}</b-badge
            >
          </p>
          <p>{{ orgtestspace.reason }}</p>
        </div>

        <div class="flex-parent2">
          <p>
            <span style="color: green"
              >Start{{
                orgtestspace.test_state == "expired" ||
                orgtestspace.test_state == "ongoing"
                  ? "ed"
                  : "s"
              }}:</span
            >
            {{ dataFormatter(orgtestspace.test_startdate, orgtestspace.test_starttime) }}
          </p>
          <p>
            <span style="color: red"
              >End{{ orgtestspace.test_state == "expired" ? "ed" : "s" }}:</span
            >
            {{ dataFormatter(orgtestspace.test_enddate, orgtestspace.test_endtime) }}
          </p>
        </div>

        <div
          v-if="
            orgtestspace.test_state == 'approaching' ||
            orgtestspace.test_state == 'ongoing'
          "
          class="flex-parent2"
        >
          <p class="test-state">
            Test
            {{ orgtestspace.test_state == "approaching" ? "opens" : "closes" }}
            in
          </p>
          <Timer
            @autosubmit="$emit('fetch')"
            :timeer="orgtestspace.test_timer"
            class="timer mr-lg-3 mr-1 pt-1"
          ></Timer>
        </div>

        <div v-if="orgtestspace.test_status == 'Opened'" class="flex-parent2">
          <div>
            Test is Currently
            <b-badge
              class="p-2 m-2"
              :variant="orgtestspace.take_lock == 'Locked' ? 'danger' : 'success'"
              >{{ orgtestspace.take_lock }}</b-badge
            >
            For you because {{ orgtestspace.lock_reason }}
          </div>
        </div>
      </div>

      <div class="button-take pr-4">
        <div></div>
        <div class="">
          <p class="text-powered pt-2">
            Powered by <span>{{ orgtestspace.organization }}</span>
          </p>
        </div>
        <b-button
          style="width: 150px;height: 50px"
          :disabled="
            orgtestspace.take_lock == 'Locked' || orgtestspace.test_status == 'Closed'
          "
          variant="success"
          @click="takeTest()"
          >{{
            orgtestspace.test_module == "Competition" ? "Enter Competition" : "Take Test"
          }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Timer from "@/components/Timer.vue";

export default {
  components: {
    Timer,
  },
  props: ["orgtestspace", "sn", "page", "interval"],
  mixing: ["utils"],
  data() {
    return {
      overallscore: 0,
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      select: this.getselected(),
      countdown: 5,
      proceeding: false,
    };
  },
  created() {},
  methods: {
    ...mapActions(["dashboard/getminiorgtestspaces"]),
    ...mapActions("exam", ["setSelect"]),
    dataFormatter(date, time) {
      let sdate = new Date(`${date} ${time}`);
      let sdatestring =
        this.monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();

      let stimestring =
        (sdate.getHours() <= 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10 ? `0${sdate.getMinutes()}` : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");

      return sdatestring + " at " + stimestring;
    },
    getselected() {
      return {
        organization: "",
        organization_id: "",
        category: null,
        institution: null,
        institution_id: null,
        level: null,
        course: null,
        scholarship: null,
        subjects: [],
        topics: [],
        reducer: 25,
        questionspertopic: 5,
        minutesperquestion: 1,
        mode: "Prototype",
        testspaceid: "",
        testsource: "thirdparty",
        candidate: this.$store.state.loginmaster.details,
      };
    },
    takeTest() {
      this.proceeding = true;

      this.select.organization = this.orgtestspace.organization;
      this.select.organization_id = this.orgtestspace.organization_id;
      this.select.category = this.orgtestspace.test_category;
      this.select.institution = this.orgtestspace.test_institution;
      this.select.institution_id = this.orgtestspace.test_institution_id;
      this.select.level = this.orgtestspace.test_level;
      this.select.course = this.orgtestspace.test_course;
      this.select.subjects = this.orgtestspace.test_subjects;
      this.select.mode = this.orgtestspace.test_mode;
      this.select.testspaceid = this.orgtestspace.trackid;
      this.select.candidate = this.details;

      return this.setSelect(this.select).then(() => {
        this.proceeding = false;

        if (this.ongoing) {
          // this.countdown = this.countdown - 1;
          this.$bvModal.show("modal-resume");
        } else if (this.start_config.start == "Yes") {
          this.$router.push({
            name: "confirm",
          });
        }
      });
    },
    movedown() {
      let categoryName = JSON.parse(this.start_config.category).name;
      // console.log( JSON.parse(this.start_config.category).name)
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
          category: categoryName,
          institution: this.start_config.institution_shortname,
        },
      });
    },
  },
  computed: {
    ...mapState({
      allinstitutions: (state) => state.admin.listinstitutions,
      details: (state) => state.loginmaster.details,
      ongoing: (state) => state.ongoing,
      start_config: (state) => state.exam.start_config,
    }),
  },
};
</script>

<style scoped>
.minidiv {
  border-radius: 10px 10px;
  background-color: white;
  /* padding: 5px; */
}

.rins {
  font-size: 0.75rem;
}

.lowscore {
  color: red;
}

.highscore {
  color: #263056;
}

.totsco {
  color: #263056;
  font-weight: bolder;
}

.brel {
  text-decoration: none;
  color: black;
}
.link-sol {
  text-decoration: none;
  color: #00984a;
}

.test-title {
  font-weight: bold;
  padding-left: 10px;
}

.flex-parent {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 15px 0px 0px;
  gap: 10px;
  justify-content: space-between;
  /* height: 35px; */
}

.flex-parent2 {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 0px 10px;
  gap: 10px;
  justify-content: flex-start;
  /* height: 35px; */
}
.test-state {
  font-size: 18px;
  margin-top: 13px;
}

.flex-child {
  width: 15%;
}

.button-take {
  display: flex;
  flex-flow: row;
  padding: 0px 10px 0px 10px;
  margin-top: 15px;
  gap: 10px;
  justify-content: space-between;
}

.text-powered {
  font-size: 14px;
  font-style: italic;
}

@media screen and (max-width: 999px) {
  .button-take {
    display: flex;
    flex-flow: row;
    padding: 0px 10px 0px 10px;
    margin-top: 15px;
    gap: 10px;
    justify-content:space-between;
  }
}

@media screen and (max-width: 999px) {
  .flex-child {
    font-size: 0.6rem;
  }
  .link-sol {
    font-size: 0.7rem;
  }
  .list-button {
    width: contain;
    font-size: 0.6rem;
    padding: 3px;
  }
  .test-state {
    font-size: 18px;
    margin-top: 8px;
  }
}
</style>
